module.exports = __webpack_public_path__ + "static/JG0-f832020b67b91a467dad20acbb3c6843.png";